import React from 'react';
import { Carousel } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import '../../../assets/scss/style.scss';
import '../../../assets/scss/affiliate.scss';
import '../../../assets/scss/mobile.scss';
import Aos from 'aos';
import work1 from '../../../assets/images/affiliate/work1.svg';
import work2 from '../../../assets/images/affiliate/work2.svg';
import work3 from '../../../assets/images/affiliate/work3.svg';
import work4 from '../../../assets/images/affiliate/work4.svg';
import work5 from '../../../assets/images/affiliate/work5.svg';
import work6 from '../../../assets/images/affiliate/work6.svg';
import 'aos/dist/aos.css';
import HomeHeaderMobile from '../../../layouts/partial/homeHeaderMobile';
import 'react-slideshow-image/dist/styles.css';
import AppConstants from '../../../appConstants';


Aos.init({ duration: 1000 });

const AffiliateComponent = () => {
  const history = useHistory();

  const handleClickLogin = () => {
    history.push(AppConstants.routes.affiliate.login);
  };

  const handleClickWelcome = () => {
    history.push(AppConstants.routes.affiliate.accountType);
  };

  const handleDontAccount = () => {
    history.push({
      pathname: AppConstants.routes.affiliate.accountType,
      state: { dontAccount: true }
    });
  };

  return (
    <>
      <Helmet>
        <title>Affiliate Program | Lovrican</title>
        <meta
          name="description"
          content="Make extra money by joining Lovrican's Affiliate Program and getting paid to help us spread the joy of true love and happiness to Africans around the world. Learn more."
        />
        <meta name="keywords" content="Affiliate Program" />
      </Helmet>
      <div className="affiliate-wrapper" id="fullpage">
        <section className="top-banner one_section full-height ">
          <div className="homeTop_stick">
            <div
              className="gift-home"
              aria-hidden="true"
              onClick={handleClickLogin}
            >
              Member Login
            </div>
            <HomeHeaderMobile />
          </div>
          <div className="caption">
            <h1>
              Earn Money by Spreading Love and Happiness!
            </h1>
            <p>
              Join Lovrican’s simple and rewarding affiliate program to make money by helping African professionals find love and happiness. The best part? Your earnings have no limit!
            </p>
            <div>
              <span
                className="round-button purple-theme"
                role="button"
                aria-hidden="true"
                onClick={handleClickWelcome}
              >
                Let’s Start
              </span>
            </div>
          </div>
        </section>
        <section className="love-arpiration love_arp_first text-left">
          <div className="container">
            <div className='row tophead_newAdd'>
              <div className='col-md-4'>
                <div className='wrap'>
                  <h3>30%</h3>
                  <p>30% of Revenue Paid Directly to <br />
                    You! Receive your payments <br />
                    regularly and with ease.*</p>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='wrap'>
                  <h3>100%</h3>
                  <p>100% Trust and Transparency! <br />
                    Enjoy full control and track every <br /> detail effortlessly.</p>
                </div>
              </div>
              <div className='col-md-4'>
                <div className='wrap'>  <h3>Growing Demand</h3>
                  <p>Large and growing demand! <br />
                    Reach millions of potential <br /> customers ready to connect.</p>
                </div>

              </div>
              <div className='col-md-12'>
                <div className='membership_note'>*Enjoy 30% of first month subscription fee.
                  % revenue subject to change.</div>
              </div>
            </div>
          </div>
        </section>
        <section className="second_section aff_second_sec full-height ">
          <div className="container">
            <div className="caption">
              <div className='max-width'>
                <h1>
                  Help Others Find Love and Be Thanked!
                </h1>
                <p>
                  Lovrican is the premier online destination for outstanding African professionals, connecting kind, beautiful, and brilliant people you’d proudly introduce to your mother.


                </p>
                <p>Your friends, family, and social media followers will thank you for helping them find their perfect match on Lovrican, the dating platform for exceptional African professionals!</p>
              </div>
            </div>
          </div>
        </section>
        <section className="third_section desktop_view">
          <div className="container">
            <div className="caption">
              <h1>
                How the <br />
                Lovrican <br />
                Affiliate <br />
                Program <br />
                Works <br />
                for You
              </h1>
            </div>
            <div className="easy_to_use_features">
              <div className="row">
                <div className="com-md-4 col-sm-6 col-lg-4 top-space">
                  <div className="box box1">
                    {/* <div className="number">1</div> */}
                    <img src={work1} alt="" />
                    <h3>
                      Submit Your Affiliate <br /> Profile and Start <br /> Earning!
                    </h3>
                    <p>
                      Creating your affiliate profile is the first step to start earning money by sharing Lovrican, the top online platform for exceptional African professionals looking for lasting love, happiness, and career success with a partner who understands them personally and professionally.
                    </p>
                  </div>
                </div>
                <div className="com-md-4 col-sm-6 col-lg-4 top-space">
                  <div className="box box2">
                    {/* <div className="number">2</div> */}
                    <img src={work2} alt="" />
                    <h3>
                      Careful Profile <br />
                      Review and <br />
                      Approval
                    </h3>
                    <p>
                      At Lovrican, we take great pride in our exclusive
                      At Lovrican, we value our trusted and welcoming community. We carefully review profiles and approve only those that meet our high standards of trust, success, and shared values.
                    </p>
                  </div>
                </div>
                <div className="com-md-4 col-sm-6 col-lg-4 top-space">
                  <div className="box box3">
                    {/* <div className="number">3</div> */}
                    <img src={work3} alt="" />
                    <h3>
                      Manage Your <br />
                      Affiliate Account <br />
                      Easily
                    </h3>
                    <p>
                      You’ll get a personal page to manage everything about your affiliate account. Here, you’ll find your unique affiliate link and QR code to share with others. You can also track how many people you referred, how many joined, and how much you’ve earned.
                    </p>
                  </div>
                </div>
                <div className="com-md-4 col-sm-6 col-lg-4 top-space">
                  <div className="box box4">
                    {/* <div className="number">4</div> */}
                    <img src={work4} alt="" />
                    <h3>
                      The More You Share, <br /> the More You Earn
                    </h3>
                    <p>
                      Share your affiliate link with your network and anyone who could benefit from Lovrican’s services, and get paid for it! The more people you help find love, the more you can earn. There’s no limit to how much you can make.
                    </p>
                  </div>
                </div>
                <div className="com-md-4 col-sm-6 col-lg-4 top-space">
                  <div className="box box5">
                    {/* <div className="number">5</div> */}
                    <img src={work5} alt="" />
                    <h3>
                      Get Paid <br />
                      Every Month
                    </h3>
                    <p>
                      At the end of each month, Lovrican will pay you the money you’ve earned. We use Zelle for payments, so you get to keep more of your earnings with no transaction fees. If you prefer another payment method, just let us know!
                    </p>
                  </div>
                </div>
                <div className="com-md-4 col-sm-6 col-lg-4 top-space">
                  <div className="box box6">
                    {/* <div className="number">6</div> */}
                    <img src={work6} alt="" />
                    <h3>
                      Earn More From <br />
                      Your Network
                    </h3>
                    <p>
                      Ask the people in your network to share your affiliate link with others who can benefit from Lovrican’s services. As new users sign up through those referrals, you’ll earn more and watch your earnings grow significantly.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row d-none">
                <div className="col-md-12 text-center readyToStart">
                  <h1>Ready to start earning?</h1>
                  <div>
                    <span
                      className="round-button purple-theme"
                      role="button"
                      aria-hidden="true"
                      onClick={handleClickWelcome}
                    >
                      Let’s Start
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div className='max-container'>
            <div className="row ">
              <div className="col-md-12 text-center readyToStart">
                <p>When others in your network tell their family and friends about Lovrican, and those people find their soulmates on our platform, we move closer to our goal of helping every African find lasting love and happiness. In return, you will be well rewarded for your contribution.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="third_section mobile_view">
          <div className="container">
            <div className="easy_to_use_features">
              <div className="caption">
                <h1>
                  How the
                  Lovrican
                  Affiliate
                  Program
                  Works
                  for You
                </h1>
              </div>

              <Carousel controls={false}>
                <Carousel.Item>
                  <div className="box box1">
                    {/* <div className="number">1</div> */}
                    <img src={work1} alt="" />
                    <h3>
                      Submit Your Affiliate <br /> Profile and Start <br /> Earning!
                    </h3>
                    <p>
                      Creating your affiliate profile is the first step to start earning money by sharing Lovrican, the top online platform for exceptional African professionals looking for lasting love, happiness, and career success with a partner who understands them personally and professionally.
                    </p>
                  </div>

                </Carousel.Item>
                <Carousel.Item>
                  <div className="box box2">
                    {/* <div className="number">2</div> */}
                    <img src={work2} alt="" />
                    <h3>
                      Careful Profile <br />
                      Review and <br />
                      Approval
                    </h3>
                    <p>
                      At Lovrican, we take great pride in our exclusive
                      At Lovrican, we value our trusted and welcoming community. We carefully review profiles and approve only those that meet our high standards of trust, success, and shared values.
                    </p>
                  </div>

                </Carousel.Item>
                <Carousel.Item>

                  <div className="box box3">
                    {/* <div className="number">3</div> */}
                    <img src={work3} alt="" />
                    <h3>
                      Manage Your <br />
                      Affiliate Account <br />
                      Easily
                    </h3>
                    <p>
                      You’ll get a personal page to manage everything about your affiliate account. Here, you’ll find your unique affiliate link and QR code to share with others. You can also track how many people you referred, how many joined, and how much you’ve earned.
                    </p>
                  </div>

                </Carousel.Item>
                <Carousel.Item>
                  <div className="box box4">
                    {/* <div className="number">4</div> */}
                    <img src={work4} alt="" />
                    <h3>
                      The More You Share, <br /> the More You Earn
                    </h3>
                    <p>
                      Share your affiliate link with your network and anyone who could benefit from Lovrican’s services, and get paid for it! The more people you help find love, the more you can earn. There’s no limit to how much you can make.
                    </p>
                  </div>

                </Carousel.Item>
                <Carousel.Item>
                  <div className="box box5">
                    {/* <div className="number">5</div> */}
                    <img src={work5} alt="" />
                    <h3>
                      Get Paid <br />
                      Every Month
                    </h3>
                    <p>
                      At the end of each month, Lovrican will pay you the money you’ve earned. We use Zelle for payments, so you get to keep more of your earnings with no transaction fees. If you prefer another payment method, just let us know!
                    </p>
                  </div>

                </Carousel.Item>
                <Carousel.Item>
                  <div className="box box6">
                    {/* <div className="number">6</div> */}
                    <img src={work6} alt="" />
                    <h3>
                      Earn More From <br />
                      Your Network
                    </h3>
                    <p>
                      Ask the people in your network to share your affiliate link with others who can benefit from Lovrican’s services. As new users sign up through those referrals, you’ll earn more and watch your earnings grow significantly.
                    </p>
                  </div>

                </Carousel.Item>
              </Carousel>

            </div>
            <div className='max-container'>
              <div className="row ">
                <div className="col-md-12 text-center readyToStart">
                  <p>When others in your network tell their family and friends about Lovrican, and those people find their soulmates on our platform, we move closer to our goal of helping every African find lasting love and happiness. In return, you will be well rewarded for your contribution.</p>
                </div>
              </div>
            </div>
          </div>

        </section>
        <section className="forth_section full-height">
          <div className="container">
            <div className="caption">
              <h1>
                Ready to <br /> make money?
              </h1>
              <div>
                <span
                  className="round-button purple-theme"
                  role="button"
                  aria-hidden="true"
                  onClick={handleClickWelcome}
                >
                  Let’s go!
                </span>
              </div>
            </div>
          </div>
        </section>

        <section className="fifth_section full-height desktop_view">
          <div className="custom_container">
            <div className="box">
              <div className="caption">
                <h3>
                  High-quality <br /> product at an <br /> unbeatable value
                </h3>
                <p>Chosen by successful African professionals.</p>
              </div>
            </div>
            <div className="box">
              <div className="caption">
                <h3>
                  Competitive <br /> compensation
                </h3>
                <p>30%* of revenue paid to you regularly.</p>
              </div>
            </div>
            <div className="box">
              <div className="caption">
                <h3>
                  Growing and <br /> Expanding Demand
                </h3>
                <p>A vital need, with millions of potential customers.</p>
              </div>
            </div>
            <div className="box">
              <div className="caption">
                <h3>
                  Trust and <br /> Transparency
                </h3>
                <p>Enjoy 100% control and traceability of every event.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="fifth_section full-height mobile_view">
          <Carousel controls={false}>
            <Carousel.Item>
              <div className="box first_box">
                <div className="caption">
                  <h3>
                    High-quality <br /> product at an <br /> unbeatable value
                  </h3>
                  <p>Chosen by successful African professionals.</p>
                </div>
              </div>

            </Carousel.Item>
            <Carousel.Item>
              <div className="box second_box">
                <div className="caption">
                  <h3>Competitive <br /> compensation</h3>
                  <p>30%* of revenue paid to you regularly.</p>
                </div>
              </div>

            </Carousel.Item>
            <Carousel.Item>
              <div className="box third_box">
                <div className="caption">
                  <h3>Growing and <br /> Expanding Demand</h3>
                  <p>A vital need, with millions of potential customers.</p>
                </div>
              </div>

            </Carousel.Item>
            <Carousel.Item>
              <div className="box forth_box">
                <div className="caption">
                  <h3>Trust and <br /> Transparency</h3>
                  <p>Enjoy 100% control and traceability of every event.</p>
                </div>
              </div>

            </Carousel.Item>
          </Carousel>
        </section>
        <section className="sixteen_section">
          <div className="container">
            <div className="caption">
              <h1>
                Let’s Start <br /> Your Affiliate <br /> Program
              </h1>
              <p>
                If you’re already a Lovrican member, simply use your existing Lovrican login to start your affiliate program.
              </p>
              <div className="account-section">
                <div className="customeRadio_Inner">
                  <div>
                    <input
                      type="radio"
                      id="lovricain_account"
                      name="radio-group"
                      onClick={handleClickLogin}
                    />
                    <label htmlFor="lovricain_account">
                      I have a Lovrican account
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="lovricain_account_not"
                      name="radio-group"
                      onClick={handleDontAccount}
                    />
                    <label htmlFor="lovricain_account_not">
                      I don’t have a Lovrican account
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AffiliateComponent;
